import { EnvConfig } from '../config';

export const config: EnvConfig = {
  gtmId: 'GTM-N53DH7Z',
  gtmAuth: '9QStrOlnL3YsT-S_G8Nddw',
  gtmPreview: 'env-6',
  splitIoAuthKey: 'gh5stqu989900vkpmc1jme4646cljmadgfbc',
};
